import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectBlocks } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

interface ConnectedProps {
    blocks: string;
}

type Props = OwnProps & ConnectedProps;

export class BlocksTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { blocks } = this.props;

        return <TableCell>{blocks}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    blocks: makeSelectBlocks()
});

export default connect(mapStateToProps)(BlocksTableCellComponent);
